import {
  REACT_APP_CLIENT_ID,
  REACT_APP_CLIENT_SECRET,
  apiIdioma,
  apiImagenLogin,
  apiListaEtiquetas,
  apiRenuevaTokenGlo,
  codigoApp,
  codigoIntitucion,
} from "../../config/constantes";


const prometeValidarApi = (api, config) => {
  return new Promise((resolver, rechazar) => {
    fetch(api, config).then((data) => {

      if (data.status == 200) {
        resolver(data);
      } else {
        rechazar(new Error(data));
      }
    });
  });
};

let listado_etiquetas = async (codigoIdioma, setListadoEtiquetas, setLoading) => {


  try {

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

      },
      body: JSON.stringify({
        p_cidioma: Number(codigoIdioma),
        p_caplicacion: Number(codigoApp),
      }),
    };

    setLoading(true)
    const listaDatosEtiquetas = await prometeValidarApi(
      `${apiListaEtiquetas}`,
      config
    );

    const listaDatosEtiquetasJson = await listaDatosEtiquetas.json();
    const { Data } = listaDatosEtiquetasJson;


    sessionStorage.setItem("etiquetas", JSON.stringify(Data));
    setListadoEtiquetas(Data);

  } catch (error) {
    setLoading(false)
    throw error;
  } finally {
    setLoading(false)
  }


};

let listado_idiomas = async (setListadoIdiomas, setLoadingAuth) => {


  try {

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

      },
      body: JSON.stringify({
        p_cinstitucion: codigoIntitucion,
      }),
    };
    setLoadingAuth(true);
    const listaIdiomas = await prometeValidarApi(`${apiIdioma}`, config);

    const listaIdiomasJson = await listaIdiomas.json();
    const { Data } = listaIdiomasJson;
    setListadoIdiomas(Data);

    sessionStorage.setItem("listIdiomas", JSON.stringify(Data))



  } catch (error) {
    setLoadingAuth(false);
    throw error
  } finally {
    setLoadingAuth(false);
  }

};

let listado_img_login = async (setListadoImgLogin) => {


  try {

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

      },
      body: JSON.stringify({
        p_cinstitucion: codigoIntitucion,
        p_caplicacion: codigoApp
      }),
    };


    const listaImgLogin = await prometeValidarApi(apiImagenLogin, config);

    const listaImgLoginJson = await listaImgLogin.json();
    const { Data } = listaImgLoginJson;
    setListadoImgLogin(Data);

  } catch (error) {

    throw error
  } finally {

  }
}




let crearTokenGlo = async () => {

  const data = {
    client_id: REACT_APP_CLIENT_ID,
    client_secret: REACT_APP_CLIENT_SECRET,
    grant_type: "client_credentials",
  };
  let formBody = [];
  for (var property in data) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&");

  try {
    let token = await fetch(apiRenuevaTokenGlo, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formBody,
    });

    let respuesta = await token.json();

    let segundosAminutos = respuesta.expires_in / 60;
    let currentDate = new Date();
    let fechaFuturaExpira = new Date(
      currentDate.getTime() + segundosAminutos * 60000
    );

    localStorage.setItem(
      "tokenGlo",
      JSON.stringify({
        access_token: respuesta.access_token,
        expires_in: fechaFuturaExpira,
      })
    );
    return {
      access_token: respuesta.access_token,
      expires_in: fechaFuturaExpira,
    }
  } catch (error) {

  }


};
export { listado_etiquetas, listado_idiomas, listado_img_login, crearTokenGlo };
